import cloneDeep from 'lodash/cloneDeep';

import LinkData from 'redpoints-model-js/model/linkdata/LinkData';

export const getLinkDataStateCopy = state =>
  state.data ? cloneDeep(state) : { ...state, data: new LinkData() };
